import { get } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'
import { RENTAL_FEE_ACCOUNTS_TAB_ID } from 'components/pricing/RentalFees/details/settings'

const rentalFeesSlice = createSlice({
  name: 'rentalFees',
  initialState: {
    isCreateEditRentalFeeDialogOpen: false,
    archivedRestoredRentalFee: undefined,
    rentalFeeTab: RENTAL_FEE_ACCOUNTS_TAB_ID,
  },
  reducers: {
    setIsCreateEditRentalFeeDialogOpen: (state, action) => {
      state.isCreateEditRentalFeeDialogOpen = action.payload
    },
    setArchivedRestoredRentalFee: (state, action) => {
      state.archivedRestoredRentalFee = action.payload
    },
    setRentalFeeTab: (state, action) => {
      state.rentalFeeTab = action.payload
    },
  },
})

export const { setIsCreateEditRentalFeeDialogOpen, setArchivedRestoredRentalFee, setRentalFeeTab } = rentalFeesSlice.actions

export const selectIsCreateEditRentalFeeDialogOpen = s => get(s, 'rentalFees.isCreateEditRentalFeeDialogOpen', false)
export const selectArchivedRestoredRentalFee = s => get(s, 'rentalFees.archivedRestoredRentalFee')
export const selectRentalFeeTab = s => get(s, 'rentalFees.rentalFeeTab')

export default rentalFeesSlice.reducer
